import { forwardRef } from "react";

import { mergeClassNames } from "utils/common";

const Image = forwardRef(({ className, src, alt, ...props }, ref) => {
	return <img ref={ref} src={src} alt={alt} className={mergeClassNames("vs--image", className)} {...props} />;
});

export default Image;
